import axios from '@/util/axios'
import debug from '@/util/debug'

const fnm = 'api/rpv.js'
const URL = process.env.VUE_APP_ROOT_API + '/prpv/api'

export default {
	consPortalTransp: (filtros) => {
        debug(null, 'consPortalTransp', fnm)
        let p = ""
        
        if(filtros.nrProcesso)
            p +="&nrProcesso=" + filtros.nrProcesso
        
        if(filtros.nome)
            p += "&nmBenficiario=" + filtros.nome
        
        if(filtros.documento)
            p += "&docBeneficiario=" + filtros.documento            
            
        if(filtros.dataIni)
            p += "&dtPgtoIni=" + filtros.dataIni

        if(filtros.dataFim)
            p += "&dtPgtoFim=" + filtros.dataFim
        
        if(p)
            p = '?' + p.substring(1)

        return axios.get(`${URL}/v1/rpv/consulta-portal-transparencia${p}`)
    },
    emitirCompPagtoPortalTransp: (idRpv) => {
        debug(null, 'emitirCompPagtoPortalTransp', fnm)
        return axios.get(`${URL}/v1/rpv/comp-pagto-portal-transparencia/${idRpv}`, {responseType: 'blob'})
    },
    baixarArqPdfConsRpvPortal: (filtros) => {
        debug(null, 'baixarArqPdfConsRpvPortal', fnm)
        let p = ""
        
        if(filtros.nrProcesso)
            p +="&nrProcesso=" + filtros.nrProcesso
        
        if(filtros.nome)
            p += "&nmBenficiario=" + filtros.nome
        
        if(filtros.documento)
            p += "&docBeneficiario=" + filtros.documento            
            
        if(filtros.dataIni)
            p += "&dtPgtoIni=" + filtros.dataIni

        if(filtros.dataFim)
            p += "&dtPgtoFim=" + filtros.dataFim
        
        if(p)
            p = '?' + p.substring(1)        

        return axios.get(`${URL}/v1/rpv/pdf-consulta-portal-transparencia${p}`, {responseType: 'blob'})
    },
    baixarArqCsvConsRpvPortal: (filtros) => {
        debug(null, 'baixarArqCsvConsRpvPortal', fnm)
        let p = ""
        
        if(filtros.nrProcesso)
            p +="&nrProcesso=" + filtros.nrProcesso
        
        if(filtros.nome)
            p += "&nmBenficiario=" + filtros.nome
        
        if(filtros.documento)
            p += "&docBeneficiario=" + filtros.documento            
            
        if(filtros.dataIni)
            p += "&dtPgtoIni=" + filtros.dataIni

        if(filtros.dataFim)
            p += "&dtPgtoFim=" + filtros.dataFim
        
        if(p)
            p = '?' + p.substring(1)        

        return axios.get(`${URL}/v1/rpv/csv-consulta-portal-transparencia${p}`, {responseType: 'blob'})
    }
}
